import React, { useState, useEffect, useRef } from "react";
import "./Carousel.css";

function Carousel({ images }) {
  const [current, setCurrent] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const timeOutRef = useRef(null);

  useEffect(() => {
    if (autoPlay) {
      timeOutRef.current = setTimeout(() => {
        slideRight();
      }, 2500);
    }

    return () => clearTimeout(timeOutRef.current);
  }, [autoPlay, current]);

  const slideRight = () => {
    setCurrent(current === images.length - 1 ? 0 : current + 1);
  };

  const slideLeft = () => {
    setCurrent(current === 0 ? images.length - 1 : current - 1);
  };

  return (
    <div
      className="carousel"
      onMouseEnter={() => {
        setAutoPlay(false);
        clearTimeout(timeOutRef.current);
      }}
      onMouseLeave={() => {
        setAutoPlay(true);
      }}
    >
      <div className="carousel_wrapper">
        {images.map((image, index) => (
          <div
            key={index}
            className={
              index === current
                ? "carousel_card carousel_card-active"
                : "carousel_card"
            }
          >
            <img className="card_image" src={image.image} alt="" />
            <div className="card_overlay"></div>
          </div>
        ))}
        <div className="carousel_arrow_left" onClick={slideLeft}>
          &lsaquo;
        </div>
        <div className="carousel_arrow_right" onClick={slideRight}>
          &rsaquo;
        </div>
        <div className="carousel_pagination">
          {images.map((_, index) => (
            <div
              key={index}
              className={
                index === current
                  ? "pagination_dot pagination_dot-active"
                  : "pagination_dot"
              }
              onClick={() => setCurrent(index)}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
}

export const data = [
  {
    image: "/assets/images/carousel/13.png",
    title: "image1",
  },
  {
    image: "/assets/images/carousel/2.webp",
    title: "image2",
  },
  {
    image: "/assets/images/carousel/1.webp",
    title: "image3",
  },
  {
    image: "/assets/images/carousel/5.webp",
    title: "image4",
  },
  {
    image: "/assets/images/carousel/14.jpg",
    title: "image5",
  },
];

export default Carousel;
